module.exports = __webpack_public_path__ + "fonts/Segoe UI.31f5f7d.woff2";